import React from 'react';
import { createIcon } from '@stockx/icons';

const XpressShippingIcon = createIcon({
  displayName: 'XpressShippingIcon',
  viewBox: '0 0 19 18',
  path: (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37579 13.0334C6.69179 13.7174 5.71979 13.8254 5.21579 13.2854C4.67579 12.7454 4.78379 11.7734 5.46779 11.1254C5.53979 11.0534 5.64779 10.9814 5.71979 10.9094C5.03579 10.6934 4.35179 10.8014 3.88379 11.2694C3.88379 11.2694 2.91179 12.2774 3.16379 15.3374C3.16379 15.3374 5.93579 15.8414 7.23179 14.6174C7.69979 14.1854 7.80779 13.4654 7.59179 12.7814C7.51979 12.8534 7.44779 12.9254 7.37579 13.0334Z"
        fill="black"
      />
      <path
        d="M15.8714 2.98947L15.8354 2.66547L15.5114 2.62947C15.4754 2.62947 11.2994 2.12547 8.02344 5.40147L6.04344 5.11347L3.52344 7.77747L5.93544 8.35347C5.71944 8.74947 5.53944 9.18147 5.35944 9.64947L5.25144 9.90147L8.59944 13.2495L8.85144 13.1415C9.31944 12.9615 9.75144 12.7815 10.1474 12.5655L10.7234 15.0135L13.3874 12.4935L13.0994 10.4415C16.3754 7.16547 15.8714 3.02547 15.8714 2.98947ZM8.81544 12.1695L6.29544 9.64947C8.67144 3.60147 13.6394 3.38547 15.0074 3.45747C15.0794 4.82547 14.8634 9.79347 8.81544 12.1695Z"
        fill="black"
      />
      <path
        d="M10.1837 6.48186C9.67966 6.98586 9.67966 7.77786 10.1837 8.24586C10.6877 8.74986 11.4797 8.74986 11.9477 8.24586C12.4517 7.74186 12.4517 6.94986 11.9477 6.48186C11.4797 6.01386 10.6877 6.01386 10.1837 6.48186Z"
        fill="black"
      />
    </svg>
  ),
});

export default XpressShippingIcon;
